import React from "react";
import "./ProjectLanguages.css";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const ProjectLanguages = ({ logos = [] }) => {
  return (
    <div className="software-skills-main-div">
      <p><b>Technology & Stacks: </b></p>
      <ul className="dev-icons-languages">
        {logos.map((logo) => (
          <OverlayTrigger
            key={logo.name}
            placement="top"
            overlay={<Tooltip className="tooltip" id={`tooltip-top`}>{logo.name}</Tooltip>}
            container={document.body} 
          >
            <li className="software-skill-inline-languages">
              { logo.iconifyClass ? <span className="iconify" data-icon={logo.iconifyClass} data-inline="false"></span>
              :
                <span className="change-font-size">{logo.name}</span>
              }
            </li>
          </OverlayTrigger>
        ))}
      </ul>
    </div>
  );
};

export default ProjectLanguages;
